import { useMutation } from 'react-query';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';

import api from 'utils/api';
import {
  clearAllToasts,
  createErrorToast,
} from 'containers/ToastNotificationContainer/actions';

import messages from '../messages';

export const useUpgradeToStandardUser = () => {
  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  const upgradeMutation = useMutation(() => api.upgradeToStandardUser(), {
    onMutate: () => {
      dispatch(clearAllToasts());
    },
    onError: () => {
      dispatch(
        createErrorToast(formatMessage(messages.upgradeToStandardError))
      );
    },
  });

  return {
    upgradeToStandardUser: upgradeMutation.mutate,
    isLoading: upgradeMutation.isLoading,
    isSuccess: upgradeMutation.isSuccess,
    isError: upgradeMutation.isError,
  };
};
